import { Flex } from "@chakra-ui/react";
import { getTVL, getTotalKMELPoints } from "@services/index";
import { useQuery } from "@tanstack/react-query";
import KelpStatsCard from "./KelpStatsCard";
import AssetsRestakedCard from "./AssetsRestakedCard";
import { useElMerkleRoot } from "@hooks/useElMerkleRoot";
import useDappChain from "@hooks/useDappChain";

const RightSidebar = () => {
  const { isEthereumChain } = useDappChain();
  const tvlStats = useQuery({
    queryKey: ["tvlStats"],
    queryFn: async () => {
      const r = await getTVL();
      return r.data;
    },
  });

  const kelpStats = useQuery({
    queryKey: ["kelpStats"],
    queryFn: async () => {
      const r = await getTotalKMELPoints();
      return r.data;
    },
  });

  const elMerkleRoot = useElMerkleRoot();

  return (
    <Flex
      pos={{ base: "initial", xl: "fixed" }}
      right={{ base: "initial", xl: 10 }}
      top={{ base: "initial", xl: 140 }}
      w="100%"
      p={4}
      pt={{ base: 4, xl: 0 }}
      gap={4}
      direction="column"
      margin="auto"
      maxW={{ base: "100%", md: 680, xl: 280 }}
    >
      <KelpStatsCard
        tvl={tvlStats}
        kelp={kelpStats}
        elMerkleRoot={elMerkleRoot}
      />
      {isEthereumChain && <AssetsRestakedCard />}
    </Flex>
  );
};

export default RightSidebar;
